// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

export const ICON_NAMES = [
  'Ach',
  'ActivityFeed',
  'Add',
  'AdvancedFilters',
  'AgentHub',
  'AggregateDataSetField',
  'AiMessage',
  'AiSearch',
  'AlignCenter',
  'AlignJustify',
  'AlignLeft',
  'AlignRight',
  'Anchor',
  'Appointment',
  'Approvals',
  'ApprovalsAlt',
  'ApproveDraft',
  'Archive',
  'ArtificialIntelligence',
  'ArtificialIntelligenceEnhanced',
  'Attach',
  'AudienceTargeting',
  'AudioFile',
  'AudioInputOutput',
  'Automations',
  'BackgroundColor',
  'Bank',
  'Blank',
  'Block',
  'BlockAlignmentBottom',
  'BlockAlignmentCenter',
  'BlockAlignmentLeft',
  'BlockAlignmentMiddle',
  'BlockAlignmentRight',
  'BlockAlignmentTop',
  'Blog',
  'BoardView',
  'Bold',
  'Book',
  'Bookmark',
  'BooleanDataType',
  'Box',
  'BreezeRegenerate',
  'BreezeSend',
  'BreezeSingleStar',
  'Bubble',
  'Bulb',
  'BulletCircle',
  'BulletDiamond',
  'BulletList',
  'BulletLowerAlpha',
  'BulletLowerGreek',
  'BulletLowerRoman',
  'BulletSquare',
  'BulletUpperAlpha',
  'BulletUpperRoman',
  'CRMDevelopment',
  'Call',
  'CallIncoming',
  'CallOnHold',
  'CallOutgoing',
  'CallTranscript',
  'Calling',
  'CallingHangup',
  'CallingMade',
  'CallingMissed',
  'CallingVoicemail',
  'Campaigns',
  'Cap',
  'Card',
  'Cart',
  'Case',
  'CaseStudy',
  'Certification',
  'Chatspot',
  'CheckCircle',
  'Checkbox',
  'CheckboxChecked',
  'CheckboxIndeterminate',
  'Checklist',
  'ChevronsOutward',
  'CircleFilled',
  'CircleHollow',
  'CleanUp',
  'Clipboard',
  'ClosedCaptions',
  'CoachingPlaylist',
  'Code',
  'CodeProject',
  'CodeProjects',
  'Cog',
  'CollapseAll',
  'Column',
  'Comments',
  'Commerce',
  'CommerceHub',
  'Communication',
  'Companies',
  'Compass',
  'Conditional',
  'ConditionalFormulaDataSetField',
  'Confetti',
  'ContactCheck',
  'ContactDuplicate',
  'ContactProperties',
  'Contacts',
  'Content',
  'ContentHub',
  'Contracts',
  'ControlPanel',
  'Copy',
  'Course',
  'CreditCard',
  'Credits',
  'Crm',
  'Crop',
  'CrossSell',
  'CssFile',
  'Ctas',
  'CustomHubl',
  'CustomModules',
  'CustomObject',
  'Dark',
  'Dashboards',
  'DataAgent',
  'DataHub',
  'DataManagement',
  'DataQuality',
  'DataSync',
  'DataSyncLeft',
  'DataSyncRight',
  'Databases',
  'Date',
  'DateClose',
  'DateDataType',
  'DateOpen',
  'Deals',
  'Debug',
  'Delay',
  'Delete',
  'Description',
  'Desktop',
  'Diamond',
  'Diff',
  'Divider',
  'Documents',
  'Down',
  'DownCarat',
  'Download',
  'Downvote',
  'DownvoteFilled',
  'DragAndDropLayout',
  'DragHandle',
  'Dropbox',
  'Dropdown',
  'Duplicate',
  'DynamicFilter',
  'Edit',
  'EditColumns',
  'Ellipses',
  'Email',
  'EmailOpen',
  'EmailThreadedReplies',
  'Embed',
  'Emoji',
  'EmojiFillHappy',
  'EmojiFillNeutral',
  'EmojiFillSad',
  'EmojiLineNeutral',
  'EmojiLineSad',
  'Enlarge',
  'Enrichment',
  'Enroll',
  'EnumerationDataType',
  'EraseStyles',
  'ExcelFile',
  'Exclamation',
  'ExclamationCircle',
  'ExitFullScreen',
  'Expand',
  'ExpandAll',
  'ExternalLink',
  'Favorite',
  'FavoriteHollow',
  'FeedbackSurveys',
  'File',
  'FilledDown',
  'FilledUpAndDown',
  'FilledXCircleIcon',
  'Filter',
  'First',
  'FixedLayout',
  'FlexColumn',
  'FoldedPaper',
  'Folder',
  'FolderOpen',
  'FolderServerlessFunction',
  'FolderServerlessFunctionOpen',
  'FolderTheme',
  'FolderThemeOpen',
  'FontFile',
  'Footer',
  'Forms',
  'FormulaDataSetField',
  'Forward',
  'FullWidth',
  'GanttView',
  'GapHorizontal',
  'GapVertical',
  'Gauge',
  'Gddc',
  'GenerateChart',
  'Ghost',
  'Gift',
  'Github',
  'GithubBranch',
  'GithubCommit',
  'GithubRepository',
  'GlobalGroup',
  'Globe',
  'Goal',
  'GraphqlFile',
  'Grid',
  'GroupModule',
  'GuidedActions',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'HamburgerMenu',
  'Header',
  'HelpDesk',
  'Hide',
  'Highlight',
  'HighlyEngagedLead',
  'Home',
  'HorizontalRule',
  'HsDesignCert',
  'HtmlFile',
  'HubDB',
  'HubspotCertification',
  'ImageAlignmentLeft',
  'ImageAlignmentMiddle',
  'ImageAlignmentRight',
  'ImageAlignmentTop',
  'ImageBroken',
  'ImageGallery',
  'Inbox',
  'Indent',
  'Info',
  'InfoCircle',
  'InfoNoCircle',
  'Inline',
  'InsertImage',
  'InsertQuote',
  'InsertVideo',
  'Integrations',
  'IntegrationsSalesForce',
  'IntegrationsSurveyMonkey',
  'Invoice',
  'Italic',
  'JsFile',
  'JsonFile',
  'Kanban',
  'Key',
  'KnowledgeBase',
  'Language',
  'Last',
  'Layers',
  'LeadScoring',
  'Left',
  'LessCircle',
  'Lesson',
  'Library',
  'Light',
  'LineHeight',
  'LineItems',
  'Link',
  'ListView',
  'Lists',
  'Location',
  'Locked',
  'LogCall',
  'LogEmail',
  'LogLinkedInMessage',
  'LogMeeting',
  'LogPostalMail',
  'LogSMS',
  'LogWhatsAppMessage',
  'Logo',
  'LogoAsana',
  'LogoDescript',
  'LogoFellow',
  'LogoHeyGen',
  'LogoMCP',
  'LogoThreads',
  'LogoZoom',
  'Logout',
  'MakeDraft',
  'Map',
  'MarkdownFile',
  'Marketing',
  'MarketingEvents',
  'MarketingHub',
  'Marketplace',
  'MeetingEvent',
  'Meetings',
  'Mention',
  'Menu',
  'Merge',
  'Messages',
  'Minus',
  'Mobile',
  'MoreCircle',
  'Move',
  'Next',
  'NonbreakingSpace',
  'NotEditable',
  'NotUsingCredits',
  'Notification',
  'NotificationOff',
  'NotificationPopup',
  'NumberList',
  'NumericDataType',
  'ObjectAssociations',
  'ObjectAssociationsManyToMany',
  'ObjectAssociationsManyToOne',
  'Office365',
  'OnlineRegistration',
  'Order',
  'Outdent',
  'PaddingBottom',
  'PaddingBrokenApart',
  'PaddingHorizontal',
  'PaddingLeft',
  'PaddingRight',
  'PaddingTop',
  'PaddingVertical',
  'PaidAd',
  'PanHandMode',
  'Paragraph',
  'Partial',
  'PaymentSubscriptions',
  'PdfFile',
  'PersonCheck',
  'Personalization',
  'Piesync',
  'Pin',
  'PlayerFastForward',
  'PlayerPause',
  'PlayerPlay',
  'PlayerRewind',
  'PopOut',
  'PowerPointFile',
  'Presentation',
  'Previous',
  'PriceBook',
  'Product',
  'ProductBundle',
  'Prospecting',
  'Publish',
  'PublishingTask',
  'Question',
  'QuestionAnswer',
  'QuestionCircle',
  'Quickbooks',
  'Quote',
  'RadioButton',
  'RadioButtonSelected',
  'RatingScale',
  'RatioDataSetField',
  'ReCaptcha',
  'ReadMore',
  'ReadOnlyView',
  'RealEstateListing',
  'RecentlySelected',
  'Record',
  'Redo',
  'Refresh',
  'Registration',
  'Remove',
  'RemoveTextStyle',
  'Replace',
  'Reply',
  'ReplyAll',
  'ReplyForwardArrow',
  'ReportSpam',
  'Reporting',
  'ReportingAndData',
  'Reports',
  'RequiredProperty',
  'Retract',
  'RichText',
  'Right',
  'Rotate',
  'RotateLeads',
  'Row',
  'SEO',
  'Sales',
  'SalesHub',
  'SalesQuote',
  'SalesTemplates',
  'SaveEditableView',
  'ScreenCapture',
  'Search',
  'Section',
  'SectionHeader',
  'SeekBackward15',
  'SeekBackward30',
  'SeekForward15',
  'SeekForward30',
  'SelectMode',
  'Send',
  'Sequences',
  'ServerlessFunction',
  'Service',
  'ServiceHub',
  'Settings',
  'Share',
  'SidebarLeft',
  'SidebarLeftCollapse',
  'SidebarLeftExpand',
  'SidebarRightCollapse',
  'SidebarRightExpand',
  'Signal',
  'SignalPoor',
  'Signature',
  'SimpleBot',
  'SingleLineNumber',
  'SiteTree',
  'Sleep',
  'Sms',
  'Snooze',
  'Social',
  'SocialBlockFacebook',
  'SocialBlockGoogleplus',
  'SocialBlockInstagram',
  'SocialBlockLink',
  'SocialBlockLinkedin',
  'SocialBlockPinterest',
  'SocialBlockRss',
  'SocialBlockTwitter',
  'SocialBlockX',
  'SocialBlockXing',
  'SocialBlockYoutube',
  'SocialBlockYoutubeplay',
  'SocialConfluence',
  'SocialFacebook',
  'SocialFacebookMessenger',
  'SocialFacebookWorkplace',
  'SocialFlickr',
  'SocialGithub',
  'SocialGoogle',
  'SocialGoogleDrive',
  'SocialGoogleplus',
  'SocialHeart',
  'SocialInbound',
  'SocialInstagram',
  'SocialJira',
  'SocialLinkedin',
  'SocialMedium',
  'SocialMicrosoftTeams',
  'SocialOneDrive',
  'SocialOpenAi',
  'SocialOutlook',
  'SocialPinterest',
  'SocialPostAgent',
  'SocialReddit',
  'SocialRetweet',
  'SocialRss',
  'SocialSharePoint',
  'SocialSlack',
  'SocialSlideshare',
  'SocialSoundcloud',
  'SocialTiktok',
  'SocialTwitter',
  'SocialWhatsapp',
  'SocialX',
  'SocialXing',
  'SocialYoutube',
  'SocialYoutubeplay',
  'SortAlpAsc',
  'SortAlpDesc',
  'SortAmtAsc',
  'SortAmtDesc',
  'SortNumAsc',
  'SortNumDesc',
  'SortTable',
  'SortTableAsc',
  'SortTableAscNew',
  'SortTableDesc',
  'SortTableDescNew',
  'Spacer',
  'SpecialCharacter',
  'SpellCheck',
  'SplitModule',
  'Sprocket',
  'Star',
  'StickyNote',
  'Stop',
  'StopRecord',
  'Strike',
  'Styles',
  'Subscript',
  'Success',
  'Sun',
  'Superscript',
  'SwitchDataSetField',
  'Switcher',
  'Table',
  'Tablet',
  'Tag',
  'Tasks',
  'Teamwork',
  'TemporaryChat',
  'Test',
  'Text',
  'TextBodyExpanded',
  'TextColor',
  'TextDataType',
  'TextSnippet',
  'Theme',
  'ThemeFile',
  'ThreeDots',
  'ThumbsDown',
  'ThumbsUp',
  'Ticket',
  'Time',
  'Tools',
  'Translate',
  'Trophy',
  'TwoFAFill',
  'TwoFAOutline',
  'Unarchive',
  'Underline',
  'Underscore',
  'Undo',
  'Unlink',
  'Unlocked',
  'Unpinned',
  'Unpublish',
  'Unsnooze',
  'Up',
  'UpCarat',
  'Upgrade',
  'Upload',
  'Upvote',
  'UpvoteFilled',
  'User',
  'UserPersonalization',
  'VerticalMenu',
  'Video',
  'VideoFile',
  'VideoPlay',
  'VideoPlayerSubtitles',
  'View',
  'ViewDetails',
  'Voice',
  'Volume',
  'VolumeDown',
  'VolumeMute',
  'VolumeUp',
  'Wallet',
  'Warning',
  'WebContent',
  'WebVisitor',
  'WebVisitorSegments',
  'Webhook',
  'Website',
  'WordFile',
  'Workflows',
  'Workspaces',
  'XCircle',
  'XmlFile',
  'ZoomIn',
  'ZoomOut',
  'ZoomToFit',
] as const;

// Ported from UIIcon
// See https://git.hubteam.com/HubSpot/UIComponents/blob/master/icons/bin/constants/aliases.js
export const TRANSITIONAL_ICON_ALIASES: Record<
  string,
  (typeof ICON_NAMES)[number]
> = {
  chain: 'Link',
  'comment-o': 'Comments',
  'comments-o': 'Comments',
  contact: 'Contacts',
  copy: 'Duplicate',
  'external-link': 'ExternalLink',
  eye: 'View',
  pencil: 'Edit',
  photo: 'InsertImage',
  'upload-light': 'Upload',
  'warning-triangle': 'Warning',
} as const;

export const TRANSITIONAL_ICON_NAMES = [
  'ach',
  'activityFeed',
  'add',
  'advancedFilters',
  'agentHub',
  'aggregateDataSetField',
  'aiMessage',
  'aiSearch',
  'alignCenter',
  'alignJustify',
  'alignLeft',
  'alignRight',
  'anchor',
  'appointment',
  'approvals',
  'approvalsAlt',
  'approveDraft',
  'archive',
  'artificialIntelligence',
  'artificialIntelligenceEnhanced',
  'attach',
  'audienceTargeting',
  'audioFile',
  'audioInputOutput',
  'automations',
  'backgroundColor',
  'bank',
  'blank',
  'block',
  'blockAlignmentBottom',
  'blockAlignmentCenter',
  'blockAlignmentLeft',
  'blockAlignmentMiddle',
  'blockAlignmentRight',
  'blockAlignmentTop',
  'blog',
  'boardView',
  'bold',
  'book',
  'bookmark',
  'booleanDataType',
  'box',
  'breezeRegenerate',
  'breezeSend',
  'breezeSingleStar',
  'bubble',
  'bulb',
  'bulletCircle',
  'bulletDiamond',
  'bulletList',
  'bulletLowerAlpha',
  'bulletLowerGreek',
  'bulletLowerRoman',
  'bulletSquare',
  'bulletUpperAlpha',
  'bulletUpperRoman',
  'cRMDevelopment',
  'call',
  'callIncoming',
  'callOnHold',
  'callOutgoing',
  'callTranscript',
  'calling',
  'callingHangup',
  'callingMade',
  'callingMissed',
  'callingVoicemail',
  'campaigns',
  'cap',
  'card',
  'cart',
  'case',
  'caseStudy',
  'certification',
  'chatspot',
  'checkCircle',
  'checkbox',
  'checkboxChecked',
  'checkboxIndeterminate',
  'checklist',
  'chevronsOutward',
  'circleFilled',
  'circleHollow',
  'cleanUp',
  'clipboard',
  'closedCaptions',
  'coachingPlaylist',
  'code',
  'codeProject',
  'codeProjects',
  'cog',
  'collapseAll',
  'column',
  'comments',
  'commerce',
  'commerceHub',
  'communication',
  'companies',
  'compass',
  'conditional',
  'conditionalFormulaDataSetField',
  'confetti',
  'contactCheck',
  'contactDuplicate',
  'contactProperties',
  'contacts',
  'content',
  'contentHub',
  'contracts',
  'controlPanel',
  'copy',
  'course',
  'creditCard',
  'credits',
  'crm',
  'crop',
  'crossSell',
  'cssFile',
  'ctas',
  'customHubl',
  'customModules',
  'customObject',
  'dark',
  'dashboards',
  'dataAgent',
  'dataHub',
  'dataManagement',
  'dataQuality',
  'dataSync',
  'dataSyncLeft',
  'dataSyncRight',
  'databases',
  'date',
  'dateClose',
  'dateDataType',
  'dateOpen',
  'deals',
  'debug',
  'delay',
  'delete',
  'description',
  'desktop',
  'diamond',
  'diff',
  'divider',
  'documents',
  'down',
  'downCarat',
  'download',
  'downvote',
  'downvoteFilled',
  'dragAndDropLayout',
  'dragHandle',
  'dropbox',
  'dropdown',
  'duplicate',
  'dynamicFilter',
  'edit',
  'editColumns',
  'ellipses',
  'email',
  'emailOpen',
  'emailThreadedReplies',
  'embed',
  'emoji',
  'emojiFillHappy',
  'emojiFillNeutral',
  'emojiFillSad',
  'emojiLineNeutral',
  'emojiLineSad',
  'enlarge',
  'enrichment',
  'enroll',
  'enumerationDataType',
  'eraseStyles',
  'excelFile',
  'exclamation',
  'exclamationCircle',
  'exitFullScreen',
  'expand',
  'expandAll',
  'externalLink',
  'favorite',
  'favoriteHollow',
  'feedbackSurveys',
  'file',
  'filledDown',
  'filledUpAndDown',
  'filledXCircleIcon',
  'filter',
  'first',
  'fixedLayout',
  'flexColumn',
  'foldedPaper',
  'folder',
  'folderOpen',
  'folderServerlessFunction',
  'folderServerlessFunctionOpen',
  'folderTheme',
  'folderThemeOpen',
  'fontFile',
  'footer',
  'forms',
  'formulaDataSetField',
  'forward',
  'fullWidth',
  'ganttView',
  'gapHorizontal',
  'gapVertical',
  'gauge',
  'gddc',
  'generateChart',
  'ghost',
  'gift',
  'github',
  'githubBranch',
  'githubCommit',
  'githubRepository',
  'globalGroup',
  'globe',
  'goal',
  'graphqlFile',
  'grid',
  'groupModule',
  'guidedActions',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'hamburgerMenu',
  'header',
  'helpDesk',
  'hide',
  'highlight',
  'highlyEngagedLead',
  'home',
  'horizontalRule',
  'hsDesignCert',
  'htmlFile',
  'hubDB',
  'hubspotCertification',
  'imageAlignmentLeft',
  'imageAlignmentMiddle',
  'imageAlignmentRight',
  'imageAlignmentTop',
  'imageBroken',
  'imageGallery',
  'inbox',
  'indent',
  'info',
  'infoCircle',
  'infoNoCircle',
  'inline',
  'insertImage',
  'insertQuote',
  'insertVideo',
  'integrations',
  'integrationsSalesForce',
  'integrationsSurveyMonkey',
  'invoice',
  'italic',
  'jsFile',
  'jsonFile',
  'kanban',
  'key',
  'knowledgeBase',
  'language',
  'last',
  'layers',
  'leadScoring',
  'left',
  'lessCircle',
  'lesson',
  'library',
  'light',
  'lineHeight',
  'lineItems',
  'link',
  'listView',
  'lists',
  'location',
  'locked',
  'logCall',
  'logEmail',
  'logLinkedInMessage',
  'logMeeting',
  'logPostalMail',
  'logSMS',
  'logWhatsAppMessage',
  'logo',
  'logoAsana',
  'logoDescript',
  'logoFellow',
  'logoHeyGen',
  'logoMCP',
  'logoThreads',
  'logoZoom',
  'logout',
  'makeDraft',
  'map',
  'markdownFile',
  'marketing',
  'marketingEvents',
  'marketingHub',
  'marketplace',
  'meetingEvent',
  'meetings',
  'mention',
  'menu',
  'merge',
  'messages',
  'minus',
  'mobile',
  'moreCircle',
  'move',
  'next',
  'nonbreakingSpace',
  'notEditable',
  'notUsingCredits',
  'notification',
  'notificationOff',
  'notificationPopup',
  'numberList',
  'numericDataType',
  'objectAssociations',
  'objectAssociationsManyToMany',
  'objectAssociationsManyToOne',
  'office365',
  'onlineRegistration',
  'order',
  'outdent',
  'paddingBottom',
  'paddingBrokenApart',
  'paddingHorizontal',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingVertical',
  'paidAd',
  'panHandMode',
  'paragraph',
  'partial',
  'paymentSubscriptions',
  'pdfFile',
  'personCheck',
  'personalization',
  'piesync',
  'pin',
  'playerFastForward',
  'playerPause',
  'playerPlay',
  'playerRewind',
  'popOut',
  'powerPointFile',
  'presentation',
  'previous',
  'priceBook',
  'product',
  'productBundle',
  'prospecting',
  'publish',
  'publishingTask',
  'question',
  'questionAnswer',
  'questionCircle',
  'quickbooks',
  'quote',
  'radioButton',
  'radioButtonSelected',
  'ratingScale',
  'ratioDataSetField',
  'reCaptcha',
  'readMore',
  'readOnlyView',
  'realEstateListing',
  'recentlySelected',
  'record',
  'redo',
  'refresh',
  'registration',
  'remove',
  'removeTextStyle',
  'replace',
  'reply',
  'replyAll',
  'replyForwardArrow',
  'reportSpam',
  'reporting',
  'reportingAndData',
  'reports',
  'requiredProperty',
  'retract',
  'richText',
  'right',
  'rotate',
  'rotateLeads',
  'row',
  'sEO',
  'sales',
  'salesHub',
  'salesQuote',
  'salesTemplates',
  'saveEditableView',
  'screenCapture',
  'search',
  'section',
  'sectionHeader',
  'seekBackward15',
  'seekBackward30',
  'seekForward15',
  'seekForward30',
  'selectMode',
  'send',
  'sequences',
  'serverlessFunction',
  'service',
  'serviceHub',
  'settings',
  'share',
  'sidebarLeft',
  'sidebarLeftCollapse',
  'sidebarLeftExpand',
  'sidebarRightCollapse',
  'sidebarRightExpand',
  'signal',
  'signalPoor',
  'signature',
  'simpleBot',
  'singleLineNumber',
  'siteTree',
  'sleep',
  'sms',
  'snooze',
  'social',
  'socialBlockFacebook',
  'socialBlockGoogleplus',
  'socialBlockInstagram',
  'socialBlockLink',
  'socialBlockLinkedin',
  'socialBlockPinterest',
  'socialBlockRss',
  'socialBlockTwitter',
  'socialBlockX',
  'socialBlockXing',
  'socialBlockYoutube',
  'socialBlockYoutubeplay',
  'socialConfluence',
  'socialFacebook',
  'socialFacebookMessenger',
  'socialFacebookWorkplace',
  'socialFlickr',
  'socialGithub',
  'socialGoogle',
  'socialGoogleDrive',
  'socialGoogleplus',
  'socialHeart',
  'socialInbound',
  'socialInstagram',
  'socialJira',
  'socialLinkedin',
  'socialMedium',
  'socialMicrosoftTeams',
  'socialOneDrive',
  'socialOpenAi',
  'socialOutlook',
  'socialPinterest',
  'socialPostAgent',
  'socialReddit',
  'socialRetweet',
  'socialRss',
  'socialSharePoint',
  'socialSlack',
  'socialSlideshare',
  'socialSoundcloud',
  'socialTiktok',
  'socialTwitter',
  'socialWhatsapp',
  'socialX',
  'socialXing',
  'socialYoutube',
  'socialYoutubeplay',
  'sortAlpAsc',
  'sortAlpDesc',
  'sortAmtAsc',
  'sortAmtDesc',
  'sortNumAsc',
  'sortNumDesc',
  'sortTable',
  'sortTableAsc',
  'sortTableAscNew',
  'sortTableDesc',
  'sortTableDescNew',
  'spacer',
  'specialCharacter',
  'spellCheck',
  'splitModule',
  'sprocket',
  'star',
  'stickyNote',
  'stop',
  'stopRecord',
  'strike',
  'styles',
  'subscript',
  'success',
  'sun',
  'superscript',
  'switchDataSetField',
  'switcher',
  'table',
  'tablet',
  'tag',
  'tasks',
  'teamwork',
  'temporaryChat',
  'test',
  'text',
  'textBodyExpanded',
  'textColor',
  'textDataType',
  'textSnippet',
  'theme',
  'themeFile',
  'threeDots',
  'thumbsDown',
  'thumbsUp',
  'ticket',
  'time',
  'tools',
  'translate',
  'trophy',
  'twoFAFill',
  'twoFAOutline',
  'unarchive',
  'underline',
  'underscore',
  'undo',
  'unlink',
  'unlocked',
  'unpinned',
  'unpublish',
  'unsnooze',
  'up',
  'upCarat',
  'upgrade',
  'upload',
  'upvote',
  'upvoteFilled',
  'user',
  'userPersonalization',
  'verticalMenu',
  'video',
  'videoFile',
  'videoPlay',
  'videoPlayerSubtitles',
  'view',
  'viewDetails',
  'voice',
  'volume',
  'volumeDown',
  'volumeMute',
  'volumeUp',
  'wallet',
  'warning',
  'webContent',
  'webVisitor',
  'webVisitorSegments',
  'webhook',
  'website',
  'wordFile',
  'workflows',
  'workspaces',
  'xCircle',
  'xmlFile',
  'zoomIn',
  'zoomOut',
  'zoomToFit',
  'chain',
  'comment-o',
  'comments-o',
  'contact',
  'copy',
  'external-link',
  'eye',
  'pencil',
  'photo',
  'upload-light',
  'warning-triangle',
] as const;
